import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function EditLinkShort() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [url, setUrl] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [shortId, setShortId] = useState('');

  useEffect(() => {
    const fetchLinkShort = async () => {
      try {
        const response = await fetch(`/api/linkshorts/${id}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch link short');
        }
        
        const data = await response.json();
        setUrl(data.targetUrl);
        setIsActive(data.isActive);
        setShortId(data.shortId);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching link short:', err);
        setError('Failed to load link short. Please try again.');
        setLoading(false);
      }
    };
    
    fetchLinkShort();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`/api/linkshorts/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          targetUrl: url,
          isActive
        }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to update link short');
      }
      
      navigate('/dashboard');
    } catch (err) {
      console.error('Error updating link short:', err);
      setError('Failed to update link short. Please try again.');
    }
  };

  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  if (error) {
    return <div className="bg-red-100 text-red-700 p-4 rounded-lg">{error}</div>;
  }

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="mt-6 text-3xl font-bold mb-6">Edit Trackable Link</h1>
      
      <div className="bg-white p-6 rounded-lg shadow-md mb-6">
        <div className="mb-4">
          <h2 className="block mt-2 text-m text-gray-700 font-semibold mb-1">Current URL:</h2>
          <div className="flex items-center">
            <span className="font-medium text-blue-600">{window.location.origin}/{shortId}</span>
            <button 
              onClick={() => {
                navigator.clipboard.writeText(`${window.location.origin}/${shortId}`);
                alert('Link copied to clipboard!');
              }}
              className="ml-2 text-blue-700 hover:text-blue-800 font-semibold text-sm"
            >
              Copy
            </button>
          </div>
        </div>
        
        <div className="mb-4">
          <h2 className="block mt-2 text-m text-gray-700 font-semibold mb-1">Stats:</h2>
          <p>Created: {new Date(Date.now()).toLocaleDateString()}</p>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
        <div className="mb-4">
          <label className="block mt-2 text-m text-gray-700 font-semibold mb-1">
            Update URL:
          </label>
          <input
            type="url"
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
        </div>
        
        <div className="mb-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              className="mr-2"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
            />
            <span className="text-sm text-gray-700 font-medium">Live</span>
          </label>
          <p className="text-sm text-gray-400 mt-1">Inactive links will not redirect visitors</p>
        </div>
        
        <div className="flex flex-col justify-end sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="bg-gray-200 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-blue-700 hover:bg-blue-800 font-semibold text-white px-6 py-2 rounded"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditLinkShort;